import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Header } from "../components/Header";
import type { PageId } from "../components/Sidebar";
import { PreprocessingDrawer } from "../components/PreprocessingDrawer";
import { DownloadDrawer } from "../components/DownloadDrawer";
import { ResyncDrawer } from "../components/ResyncDrawer";
import { DiaryDrawer } from "../components/DiaryDrawer";
import { PipeScheduleDrawer } from "../components/Develop/PipeScheduleDrawer";
import { AlertsDrawer } from "../components/AlertsDrawer";
import { api } from "../lib/api";
import { MobileSidebar } from "./MobileSidebar";
import { MobileDashboard } from "./pages/MobileDashboard";
import { MobileDriveParameters } from "./pages/MobileDriveParameters";
import { MobilePumps } from "./pages/MobilePumps";
import { MobileLubrication } from "./pages/MobileLubrication";
import { MobileJackingForce } from "./pages/MobileJackingForce";

export function MobileApp() {
  const [page, setPage] = useState<PageId>("dashboard");
  const [navOpen, setNavOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [resyncOpen, setResyncOpen] = useState(false);
  const [diaryOpen, setDiaryOpen] = useState(false);
  const [pipeScheduleOpen, setPipeScheduleOpen] = useState(false);
  const [alertsOpen, setAlertsOpen] = useState(false);

  const drive = useQuery({ queryKey: ["drive"], queryFn: api.drive, refetchInterval: 10_000 });
  const tz = drive.data?.shiftTimezone ?? "Europe/Dublin";

  const navigateTo = (p: PageId) => {
    setPage(p);
    setNavOpen(false);
  };
  const openTool = (open: (v: boolean) => void) => () => {
    setNavOpen(false);
    open(true);
  };

  return (
    <div className="flex flex-col h-screen bg-bg text-text">
      <Header
        onToggleMobileNav={() => setNavOpen((v) => !v)}
        onOpenAlerts={() => setAlertsOpen(true)}
      />
      <MobileSidebar
        page={page}
        onChange={navigateTo}
        onOpenSettings={openTool(setSettingsOpen)}
        onOpenDownload={openTool(setDownloadOpen)}
        onOpenResync={openTool(setResyncOpen)}
        onOpenDiary={openTool(setDiaryOpen)}
        onOpenAlerts={openTool(setAlertsOpen)}
        onOpenPipeSchedule={openTool(setPipeScheduleOpen)}
        open={navOpen}
        onClose={() => setNavOpen(false)}
      />
      <main className="flex-1 overflow-y-auto bg-grid">
        <div className="px-3 py-3 pb-10">
          {page === "dashboard"    && <MobileDashboard timezone={tz} />}
          {page === "drive"        && <MobileDriveParameters />}
          {page === "pumps"        && <MobilePumps />}
          {page === "lubrication"  && <MobileLubrication />}
          {page === "jackingForce" && <MobileJackingForce />}
        </div>
      </main>
      <PreprocessingDrawer open={settingsOpen} onClose={() => setSettingsOpen(false)} />
      <DownloadDrawer open={downloadOpen} onClose={() => setDownloadOpen(false)} />
      <ResyncDrawer open={resyncOpen} onClose={() => setResyncOpen(false)} />
      <DiaryDrawer open={diaryOpen} onClose={() => setDiaryOpen(false)} />
      <PipeScheduleDrawer open={pipeScheduleOpen} onClose={() => setPipeScheduleOpen(false)} />
      <AlertsDrawer open={alertsOpen} onClose={() => setAlertsOpen(false)} />
    </div>
  );
}
